import styled from "styled-components"

export const Container = styled.div`
  &.invisible {
    visibility: hidden;
  }

  & label {
    display: block;
    cursor: pointer;
    font-size: 0.95rem;
    padding-bottom: 7.5px;
  }

  & label span.error {
    color: var(--error);
  }

  & label.hidden {
    display: none;
  }

  & input {
    width: 100%;
    border: 1px solid var(--border);
    border-radius: 2px;
    padding: 5.5px 7.5px;
    box-shadow: var(--boxshadow);
    -webkit-transition: box-shadow 150ms ease;
    transition: box-shadow 150ms ease;
    font-family: inherit;
    font-size: 16px;
    line-height: 25px;
    font-weight: 600;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    &:focus {
      border-color: var(--blue);
    }

    &.error {
      border-color: var(--error);
    }
  }
`
